import {LOGIN, LOGOUT} from "../constants/ActionTypes";

const initialState = {
    isAuthenticated: false,
    token: null,
};

const auth = (state = initialState, action) => {
    switch (action.type) {
        case LOGIN:
            return {
                ...state,
                isAuthenticated: true,
                token: action.payload,
            };
        case LOGOUT:
            return {
                ...state,
                isAuthenticated: false,
                token: null,
            };
        default:
            return state;
    }
};

export default auth;